<template>
  <div class="view contentBody">
   <div class="search_wrap">
				<el-form :inline="true" :model="formdata" class="form-inline">
					<el-form-item label="">
						<el-input v-model="formdata.goods_name" placeholder="请输入商品名称" class=" mr10" size="small"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary"  size="small" @click="searchcustomer">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
    <el-table :data="tableData" style="width: 100%" >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <!-- <el-table-column label="商品图片" align="center">
          <template slot-scope="scope">
            <div class="td_img">
              <img :src="scope.row.goods_thumb" alt/>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="ratio" label="毛利率" align="center"></el-table-column>
        <el-table-column fixed="right" label="操作" width="238">
          <template slot-scope="scope">
            <el-button type="primary" size="small" icon="el-icon-edit" @click="setProfit(scope.row.id)">编辑毛利率</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
                background
                @current-change="pageIndexChange"
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                layout="total, prev, pager, next"
                :total="page.total"
        ></el-pagination>
      </div>

      
  </div>
</template>

<script>
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "profit",
  filters: {//限制文本显示字数,超出部分用...代替
    ellipsis (value) {
        if (!value) return ''
        if (value.length > 25) {
          return value.slice(0,25) + '...'
        }
        return value
    },
  },
  data() {
    return {
      tableData: [],
      page: {
        current_page: pagination.pageIndex,
        page_size: pagination.pageSize,
        total_rows: pagination.total_rows
      },
      dialogTableVisible: false,
      formdata: {
        goods_name:'',
        page:1
      },
    }
  },
  created() {
    this.initFn()
  },
  methods: {
    initFn() {
      this.axios
        .post(api.goodsProfit, this.formdata)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.result;
           this.page.total = response.data.page.total_rows//总条数
          } 
        })
        .catch(() => {});  
    },
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.formdata.pageindex = pageindex
      this.initFn();
    },
    searchcustomer() {
      this.formdata.page = 1;
      this.initFn();
    },
   setProfit(id){
     this.$prompt('请输入毛利率（数值范围1-100）', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^(100)$|^((\d|[1-9]\d)(\.\d{1,2})?)$/,
          inputErrorMessage: '请输入正确的毛利率'
        }).then(({ value }) => {
         
          let data={}
          data.id= id
          data.ratio = value
        this.axios
        .post(api.setProfit, data)
        .then(response => {
          if (response.data.code == 0) {
            this.$message.success(response.data.msg)
            this.formdata.page =1
            this.initFn();
          
          } 
        })
        .catch(() => {});  
          console.log(value)
          
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });       
        });
   }

  }
}
</script>